import { type VirtualDesignFont, type VirtualDesignImage, type VirtualDesignLogo } from '../types'

// 购物车返回的artwork文件结构，对应后端 AnyPromo.Biz.Sale.Customize.ArtworkFile，字段名和前端 ArtworkFile 类型不同
export type LastCartArtworkFile = {
  SysNo: number
  FileName: string
  ThumbnailUrl: string
  Url: string
  Extension: string
  BoxNetFileSysNo: number
}

export type LastCartItemImprint = {
  Location: string
  Method: string
  IsVirtualDesign:boolean
  ArtworkFiles: LastCartArtworkFile[]
  VirtualDesignArts: LastCartArtworkFile[]
  VirtualDesignFonts: VirtualDesignFont[]
  VirtualDesignImage: VirtualDesignImage
  VirtualDesignLogo: VirtualDesignLogo[]
  VirtualDesignFileId?:number
  ImprintColor: string[]
  ArtworkText:string
  ArtworkOption: number
}

export type LastCartItem = {
  PreviousImage: string
  ImprintOptions: LastCartItemImprint[]
  ProductOptions: Record<string, string>[]
}

export const useLastCart = (): LastCartItem | undefined => {
  // 先从JSON数据里加载用户信息
  const lastCartData: LastCartItem = (window as any).lastCartData
  if (!lastCartData) {
    return undefined
  }

  return {
    PreviousImage: lastCartData.PreviousImage,
    ProductOptions: lastCartData.ProductOptions,
    ImprintOptions: lastCartData.ImprintOptions
  }
}
